import { Link, graphql, useStaticQuery } from "gatsby"
import React from "react"
import { StaticImage } from "gatsby-plugin-image";
import DownArrow from '../images/chevron-small-down.svg';

import * as headerStyles from './header.module.scss'
import { menuContext } from '../../provider'

const Header = ({ location }) => {
  
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          title
        }
      }
      
      allContentfulSubcategory (filter: {name: {nin: "Recipes"}}, sort: {name: ASC}) {
        edges {
          node {
            name
            subcategoryOf {
              name
            }
            slug
          }
        }
      }
      contentfulSubcategory (name: {eq: "Recipes"}) {
        blog_post {
          slug
        }
      }
        allContentfulMeals (sort: {name: ASC}) {
          edges {
            node {
              name
              slug
            }
          }
        }
    }
  `)


  return (
    <menuContext.Consumer>
      
      {context => (
        <React.Fragment>
          <header className={headerStyles.header} id="header">
            <div className={headerStyles.headerContainer}>
            <div className={headerStyles.logo} id="logo" >
            <Link to="/" >
              <StaticImage
                src="../images/large-color-logo-wide.png"
                loading="eager"
                placeholder="none"
                imgClassName="no-pin"
                alt="Steph Sunshine" />
              </Link>
            </div>
            <div role="presentation" aria-label="close" className={`${headerStyles.burger} ${context.menuOpen ? headerStyles.clicked : null }`} onClick={() => {context.toggleMenu()}}>
              <span></span>
            </div>
              <nav className={ context.menuOpen ? headerStyles.show : null }>
                <span></span>
                <ul role="presentation" className={headerStyles.navList} onClick={() => {context.closeMenu()}}>
                  <li className={headerStyles.navItem}>
                    <Link className={headerStyles.navItemLink} activeClassName={headerStyles.activeNavItem} to="/vegan-life/all-recipes">
                      All Recipes
                    </Link>
                  </li>
                  <li className={headerStyles.navItem}>
                    <Link className={headerStyles.navItemLink} 
                      activeClassName={headerStyles.activeNavItem} 
                      to="/vegan-life/recipes">
                      Recipes <DownArrow className={headerStyles.navIcon} />
                    </Link>
                    <ul className={headerStyles.subMenu}>
                        
                            <li key="breakfast">
                              <Link className={headerStyles.navSubItem} to="/vegan-life/recipes/breakfast-brunch">
                                Breakfast
                              </Link>
                            </li>
                            <li key="lunch">
                              <Link className={headerStyles.navSubItem} to="/vegan-life/recipes/lunch">
                                Lunch
                              </Link>
                            </li>
                            <li key="dinner">
                              <Link className={headerStyles.navSubItem} to="/vegan-life/recipes/dinner">
                                Dinner
                              </Link>
                            </li>
                            <li key="appetizers">
                              <Link className={headerStyles.navSubItem} to="/vegan-life/recipes/appetizers-snacks">
                                Appetizers
                              </Link>
                            </li>
                            <li key="desserts">
                              <Link className={headerStyles.navSubItem} to="/vegan-life/recipes/desserts-sweets">
                                Desserts
                              </Link>
                            </li>
                            <li key="beverages">
                              <Link className={headerStyles.navSubItem} to="/vegan-life/recipes/beverages">
                                Beverages
                              </Link>
                            </li>
                    </ul>
                  </li>
                  <li className={headerStyles.navItem}>
                    <Link className={headerStyles.navItemLink} activeClassName={headerStyles.activeNavItem} to="/vegan-life">
                      Vegan Life <DownArrow className={headerStyles.navIcon} />
                    </Link>
                    <ul className={headerStyles.subMenu}>
                      {data.allContentfulSubcategory.edges.map(edge => {
                        if (edge.node.subcategoryOf.name === "Vegan Life" && edge.node.name !== "Recipes") {
                          return (
                            <li key={edge.node.slug}>
                              <Link className={headerStyles.navSubItem} to={`/vegan-life/${edge.node.slug}`}>
                                {edge.node.name}
                              </Link>
                            </li>
                          )
                        }
                        return ''
                      })}
                    </ul>
                  </li>
                  <li className={headerStyles.navItem}>
                    <Link className={headerStyles.navItemLink} activeClassName={headerStyles.activeNavItem} to="/travel">
                      Travel <DownArrow className={headerStyles.navIcon} />
                    </Link>
                    <ul className={headerStyles.subMenu}>
                      {data.allContentfulSubcategory.edges.map(edge => {
                        if (edge.node.subcategoryOf.name === "Travel") {
                          return (
                            <li key={edge.node.slug}>
                              <Link className={headerStyles.navSubItem} to={`/travel/${edge.node.slug}`}>
                                {edge.node.name}
                              </Link>
                            </li>
                          )
                        }
                        return ''
                      })}
                    </ul>
                  </li>
                  
                  {/* <li className={headerStyles.navItem}><Link partiallyActive className={headerStyles.navItemLink} activeClassName={headerStyles.activeNavItem} to="/music">Music</Link></li> */}
                  {/* <li className={headerStyles.navItem}><Link partiallyActive className={headerStyles.navItemLink} activeClassName={headerStyles.activeNavItem} to="/videos">Videos</Link></li> */}
                  <li className={headerStyles.navItem}><Link partiallyActive className={headerStyles.navItemLink} activeClassName={headerStyles.activeNavItem} to="/about">About</Link></li>
                  
                </ul>
              </nav>
              <div role="presentation" id={headerStyles.overlay} className={ context.menuOpen ? headerStyles.show : null } onClick={() => {context.toggleMenu()}}></div>
              </div>
          </header>
        </React.Fragment>
      )}
  
  </menuContext.Consumer>
  );
  }


export default Header
